'use strict';

//import 'babel-polyfill';

import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import animate from 'angular-animate';
import ngSanitize from 'angular-sanitize';
import ngRoute from 'angular-route';
import ngCookies from 'angular-cookies';
import uiBoostrap from 'angular-ui-bootstrap';
import notification from 'angular-ui-notification';
import bootstrapContextMenu from 'angular-bootstrap-contextmenu';
import oclazyload from 'oclazyload';
import localStorage from 'angular-local-storage';

require('../../../../js/jquery.colorbox');
require('../../../../js/jquery.floatThead');

var isDefined = angular.isDefined,
  isUndefined = angular.isUndefined,
  isNumber = angular.isNumber,
  isObject = angular.isObject,
  isArray = angular.isArray,
  extend = angular.extend,
  toJson = angular.toJson;

// Test if string is only contains numbers
// e.g '1' => true, "'1'" => true
function isStringNumber(num) {
  return /^-?\d+\.?\d*$/.test(num.replace(/["']/g, ''));
}

import animaciones from './Utilidades/animaciones';
import temporaryStorage from './Utilidades/angular-local-storage/temporaryStorage';
import fileUpload from './Utilidades/fileUpload';
import floatingDiv from './Utilidades/floatingDiv';
import angularFileUpload from 'angular-file-upload';
import popovers from './Utilidades/popovers';
import ngTable from 'ng-table/bundles/ng-table';
import datePicker from './Utilidades/datepicker';
import tabletools from './Utilidades/tableTools';
import loader from './Utilidades/loader';

// Dependencias de la aplicaci�n

import inicio from './Inicio/InicioCtrl';
import clientes from './Clientes/clientesCtrl';
import cuenta from './Cuenta/cuentaCtrl';
import reportes from './Reportes/reportesCtrl';
import preferencias from './Preferencias/preferenciasCtrl';
import proveedores from './Proveedores/proveedoresCtrl';
import personal from './Personal/personalCtrl';
import bancos from './Bancos/bancosCtrl';
import contacto from './Contacto/contactoCtrl';
//import config from './configuration';
import directivas from './Utilidades/directivas';
import filtros from './Utilidades/filtros';
import ngOnboarding from './Utilidades/ng-onboarding';
import Authorization from './Utilidades/Authorization';
import onboarding from './Utilidades/onboarding';

import administracion from './Administracion/administracionCtrl';
import organizacion from './Organizacion/organizacionCtrl';

import servicios from '../servicios/servicios';

const m = angular.module('contartemx', [
    'ngSanitize',
    inicio.name,
    'contartemx.clientes',
    'contartemx.cuenta',
    'contartemx.reportes',
    'contartemx.preferencias',
    'contartemx.proveedores',
    'contartemx.personal',
    'contartemx.bancos',
    'contartemx.contacto',
    'contartemx.directivas',
    'contartemx.filtros',
    'contartemx.onboarding',
    'contartemx.servicios',
    'contartemx.animaciones',
    administracion.name,
    organizacion.name,
    'ngAnimate',
    'ngRoute',
    'ngCookies',
    'ui.router',
    'ui.bootstrap',
    'ui-notification',
    'temporaryStorage',
    'Authorization',
    'popovers',
    'ngOnboarding',
    onboarding.name,
    'ui.bootstrap.contextMenu',
    'oc.lazyLoad',
    'LocalStorageModule' 
])
    .config(($stateProvider, $routeProvider, $urlMatcherFactoryProvider, $urlRouterProvider, $cookiesProvider,
        ngOnboardingDefaultsProvider, $httpProvider, $windowProvider, $locationProvider, $ocLazyLoadProvider,
        localStorageServiceProvider, principalProvider, NotificationProvider) => {

      $locationProvider.hashPrefix('');
      $urlMatcherFactoryProvider.caseInsensitive(true);

      localStorageServiceProvider
          .setPrefix('contartemx');

      principalProvider.setApplication("app");

      $urlRouterProvider
        .when('/Inicio', '/Inicio/Resumen')
        .when('/Clientes', '/Clientes/VentasServicios')
        .when('/Proveedores', '/Proveedores/ComprasGastos')
        .when('/Personal', '/Personal/Nomina')
        .when('/Bancos', '/Bancos/CuentasBancarias')
        .when('/Cuenta', '/Cuenta/Administrar')
        .when('/Reportes', '/Reportes/Estados')
        .when('/Preferencias', '/Preferencias/Perfil')
        .when('/Contacto', '/Contacto')
        .when('/Administracion', '/Administracion/Cuentas')
        .when('/Organizacion', '/Organizacion/Cuentas')
        .otherwise('/Inicio/Resumen');

      ngOnboardingDefaultsProvider.set({ showButtons: false, showStepInfo: false });

      var servicioRE = /PortalServicio\.svc/i, htmlRE = /\.html$/i;

      // Interceptores de angular.
      $httpProvider.interceptors.push(($rootScope, Contribuyente, $cookies, localStorageService, $state) => {
        return {
          response(args) {
            let { config, data, headers } = args;
            // Revisa si no existe contribuyente.
            if (config.url.toLowerCase().indexOf("llenardatospantalla") > -1) {
              if (data && data.Respuesta && data.Respuesta.UsuarioInfo) {
  
                $rootScope.userInfo = data.Respuesta.UsuarioInfo;    
                if (data.Respuesta.UsuarioInfo.ClaveContribuyente < 1) {
                  var nextState = $state.transition.to().name;            
                  if (!(nextState.startsWith("administracion") || nextState.startsWith("organizacion"))) {

                    $state.transitionTo('administracion.cuentas');
                  }              
                } else {
                  $cookies.put("contribuyente", data.Respuesta.UsuarioInfo.ClaveContribuyente, { path: '/' });
                }
              }
            }

            let url = config.url || "",
              $window = $windowProvider.$get();

            if (!htmlRE.test(url)) {
              if (servicioRE.test(url)) {
                url = url.split('/').pop();
              }

              if (angular.isFunction($window.ga)) {
                if (config.requestTimestamp) {
                  $window.ga('send', {
                    hitType: 'timing',
                    timingCategory: 'request',
                    timingVar: url,
                    timingValue: new Date().getTime() - config.requestTimestamp
                  });
                }
              }
            }

            return args;
          },
          request(config) {
            config = config || {};
            let url = config.url || "",
              $window = $windowProvider.$get();

            if (!htmlRE.test(url)) {
              if (servicioRE.test(url)) {
                url = url.split('/').pop();
              }

              if (angular.isFunction($window.ga)) {

                config.requestTimestamp = new Date().getTime();

                $window.ga('send', 'event', {
                  eventLabel: url,
                  eventAction: config.method,
                  eventCategory: "REQUEST",
                });
              }
            }

            return config;
          }
        };
      });

      NotificationProvider.setOptions({
          delay: 10000,
          maxCount: 3
      });

      angular.element(document).ready(function () {
        document.getElementById("loader-wrapper").remove();
      });

    })
    .controller('indexController', ($scope, $location, $state, $transitions, $http, $timeout, mostrarNotificacion, $uibModal, callToWebService, ServicioChargebee,
        $rootScope, temporaryStorageService, onboarding, apiCall, $window, Contribuyente, localStorageService, $cookies, ServicioPermisos, principal) => {
        
      $scope.Movil = false;
      var dispositivo = navigator.userAgent.toLowerCase();
      if (dispositivo.search(/android|ipad|blackberry|windows phone|webos|iphone/) > -1)
        $scope.Movil = true;

      $scope.onboardingData = onboarding;

      $scope.subnavClass = function () {
        if ($state.includes('clientes'))
            return 'subNavigation--clientes';
        else if ($state.includes('proveedores'))
          return 'subNavigation--proveedores';
        else if ($state.includes('bancos'))
          return 'subNavigation--bancos';
        else if ($state.includes('inicio'))
          return 'subNavigation--inicio';
        else if ($state.includes('reportes'))
          return 'subNavigation--reportes';
        else if ($state.includes('personal'))
          return 'subNavigation--personal';
        else if ($state.includes('administracion'))
          return 'subNavigation--administracion';
        else if ($state.includes('organizacion'))
          return 'subNavigation--organizacion';
        else
          return 'none';
      };

      $scope.logout = function () {
        temporaryStorageService.clearAll();
        $scope.hidePopUser();
      }

      $scope.hidePopUser = function (e) {
        $('div.popover').each(function (index, elem) {
          if (!$(elem).hasClass('popover--hidden')) {
            $(elem).toggleClass('popover--hidden');
          }
        });
      };

      $scope.$on("UserInfoUpdated", (event, data) => {

        if (data.UsuarioInfo && data.UsuarioInfo.ClaveContribuyente > 0 && !data.UsuarioInfo.MembresiaActiva) {
              $state.go('administracion.cuentas');
        }

        $scope.userInfo = data.UsuarioInfo;
        $scope.CambioContrasena = data.CambioContrasena;
        $scope.CambiarCuenta = data.CambiarCuenta;
        $rootScope.AdministraOrganizaciones = data.AdministraOrganizaciones;
        $scope.timbresTotal = $scope.userInfo.TimbresEmitidos + $scope.userInfo.TimbresRestantes;
        $scope.NombreContribuyente = data.NombreContribuyente;
        $rootScope.CobrosLineaActivado = data.CobrosLineaActivado;    
   
        $timeout(() => { 
            onboarding.enabled = !onboarding.visto && $scope.userInfo.PasoOnboard < 15 && $scope.CambioContrasena && $scope.userInfo.MembresiaActiva
                && $scope.userInfo.ClaveTipoUsuario == 1 && !$state.includes('administracion');    
       
            if (onboarding.enabled && $scope.userInfo.PasoOnboard != 0) {
                onboarding.changeSteps($scope.userInfo.PasoOnboard);
            }
        });

        ServicioChargebee.obtenerSesionPortal(data.UsuarioInfo.ClaveContribuyente);

        ServicioPermisos.ReiniciarPermisos();
        $rootScope.Permisos = ServicioPermisos.Permisos;
        ServicioPermisos.ObtenerPermisos(data.Permisos);

        if ($scope.userInfo.ClaveTipoUsuario == 6 && !$scope.CambioContrasena) {
          $scope.displayPopupPassword();
        }

        if (angular.isFunction($window.ga)) {
          $window.ga('set', 'userId', $scope.userInfo.ClaveContribuyente + "-" + $scope.userInfo.ClaveUsuario); // Set the user ID using signed-in user_id.
        }

      });
        
      $scope.loadUserData = (cb) => {  
        principal.identity(true).then(data => {  
              if (data && data.userInfo) {
                $rootScope.$broadcast("UserInfoUpdated", data.userInfo);
                if (angular.isFunction(cb)) {
                  cb();
                }
              } else {
                  $window.open('/Login', '_self');
              }  
          });

      };

      $scope.AdministracionCuentas = () => $state.includes('administracion') || $state.includes('organizacion');

      $scope.AdministraOrganizacion = () => $rootScope.AdministraOrganizaciones;

      $scope.verOrganizacion = () => $scope.AdministraOrganizacion() ? $state.go("organizacion.cuentas") : $state.go("organizacion.suscripcion");

      $scope.displayPopupPassword = function () {
        var modalInstance = $uibModal.open({
          template: require('../../../app/views/CambiarContrasena_modal.html'),
          controller: ChangePassCtrl,
          windowClass: 'modal--small',
          backdrop: 'static'
        });

        modalInstance.result.then(function () {
          location.reload();
        });

      };

      $rootScope.$on('NoMostrarOnboarding', () => apiCall.post('NoMostrarOnboarding')
        .then(() => {
          onboarding.enabled = false;
        }));
        
      $transitions.onStart({}, () => {
          if ($scope.userInfo && $scope.userInfo.ClaveTipoUsuario == 6 && !$scope.CambioContrasena) {
              $scope.displayPopupPassword();
          }
      });

      var ChangePassCtrl = function ($scope, $uibModalInstance) {

        callToWebService.postCall('ObtenerPantallaAdministrarCuenta', {},
          function sucess(data) {
            $scope.Usuario = data.Respuesta;
          },
          function error(data) {
          });

        $scope.$watch('newPassword', function () {

          $scope.pwdSecurityBar = 0;
          var viewValue = $scope.newPassword;

          var pwdValidLength = (viewValue && viewValue.length >= 8 ? 'valid' : undefined);
          var pwdHasLetter = (viewValue && /[A-z]/.test(viewValue)) ? 'valid' : undefined;
          var pwdHasNumber = (viewValue && /\d/.test(viewValue)) ? 'valid' : undefined;

          if (pwdValidLength)
            $scope.pwdSecurityBar += 33;
          if (pwdHasLetter)
            $scope.pwdSecurityBar += 33;
          if (pwdHasNumber)
            $scope.pwdSecurityBar += 33;

          var pwd = $scope.pwdSecurityBar;

          if (pwd >= 0 && pwd <= 33) {
            $scope.pwdSecurityClass = 'progress-low';
            $scope.segurityLevel = "Baja"
          }
          else if (pwd >= 34 && pwd <= 66) {
            $scope.pwdSecurityClass = 'progress-medium';
            $scope.segurityLevel = "Regular"
          }
          else if (pwd >= 67) {
            $scope.pwdSecurityClass = 'progress-high';
            $scope.segurityLevel = "Alta"
          }

          if (pwd == 99)
            $scope.pwdSecurityBar = 100;

        }, true);

        $scope.saveChanges = function (form) {
          var newPass = form.newPassword.$viewValue;
          var confirmPass = form.confirmPassword.$viewValue;
          if (newPass === confirmPass) {
            var usuarioModel = {
              Nombre: form.nombre.$viewValue,
              ApellidoPaterno: form.aPaterno.$viewValue,
              ApellidoMaterno: form.aMaterno.$viewValue,
              Clave: newPass
            };
            callToWebService.postCall('EditarUsuarioContador', { Usuario: usuarioModel },
              function success(data) {
                $uibModalInstance.close();
              },
              function error(data) {

              });
          }
          else {
            $scope.alert = [];
            $scope.alert.push({
              type: 'error',
              msg: 'Las contrase\u00f1as deben ser iguales'
            });
          }
        };

        $scope.closeModalAlert = function (i) {
          $scope.alert.splice(i, 1);
        };
      };

      $scope.showModal = function (id) {
        temporaryStorageService.clearAll();
        $.colorbox({
          href: '../../../publico/LoginContador.aspx?cve=' + id,
          overlayClose: false,
          scrolling: true,
          transition: 'elastic',
          iframe: true,
          opacity: '0.35',
          width: '800px',
          height: '600px'
        });
      };

      $scope.$on("CambioContribuyente", (event, contribuyente) => {
          $cookies.put("contribuyente", contribuyente, { path: '/' });
        Contribuyente.CveContribuyente = contribuyente;

        $scope.loadUserData(function () {
          $state.go("inicio.resumen");
        });
          $scope.indiceNotificaciones = 0;
          $scope.notificaciones = [];
        obtenerNotificaciones();
      });

      $scope.obtenerNombreDeUsuario = function (nombre) {
        if (nombre != null && nombre != undefined && nombre != "") {
          return nombre;
        }
        return "Mi Perfil";
      };

      $scope.mostrarNotificacion = function (show, msg, esError) {
        var notificacion = $("#notificacion");

        notificacion.css({ 'opacity': 0.9 });

        $(window).scroll(function () {
          notificacion.toggleClass('sticky', notificacion.scrollTop() > notificacion.offset().top);
        });

        if (msg)
          notificacion.html(msg);
        if (show)
          notificacion.show().delay(8000).fadeOut();
        else
          notificacion.hide();

        notificacion.removeClass("alert-info");
        notificacion.removeClass("alert-danger");
        if (esError)
          notificacion.addClass("alert-danger");
        else
          notificacion.addClass("alert-info");
      };
        
      $scope.modalEditarUsuario = () => {
          var modalInstance = $uibModal.open({
              template: require('../../../app/views/Cuenta/EmailContrasena_modal.html'),
              controller: 'EditarNombreContraseniaUsuarioCtrl',
              windowClass: 'modal--small',
              resolve: {
                  datos () {
                      return {
                          UsuarioPersonaNombre: $scope.userInfo.Nombre,
                          UsuarioApaterno: $scope.userInfo.ApellidoPaterno,
                          UsuarioAmaterno: $scope.userInfo.ApellidoMaterno,
                          UsuarioCorreo: $scope.userInfo.NombreUsuario,
                      };
                  }

              }
          });

          modalInstance.result.then((data) => {
              if (data.CodigoRespuesta == 200) {
                  $scope.llamadoPantalla = $scope.llamadoPantalla + 1;
                  mostrarNotificacion.info("Se han guardado los cambios");
                  console.log(data);
                  $scope.userInfo = $scope.userInfo || {};
                  if (data.Respuesta) {
                      $scope.userInfo.NombrePersona = `${data.Respuesta.Nombre} ${data.Respuesta.ApellidoPaterno} ${data.Respuesta.ApellidoMaterno}`;                    
                  } 
              }
              else {
                  $scope.mostrarNotificacion(true, data.Mensaje, true);
              }

          });
      };

      $scope.indiceNotificaciones = 0;

      const obtenerNotificaciones = indice => {
        
        apiCall.post('ObtenerNotificaciones', { indice: $scope.indiceNotificaciones, contribuyente: Contribuyente.CveContribuyente })
          .then(data => {

            if (data.CodigoRespuesta == 200 && data.Respuesta && angular.isArray(data.Respuesta.Notificaciones)) {

              $scope.notificaciones = $scope.notificaciones || [];

              const nuevasNotificaciones = data.Respuesta.Notificaciones;              
              nuevasNotificaciones.forEach(n => {
                switch (n.CveTipoNotificacion) {
                  case 1: n.Icono = 'icon--user';
                    break;
                  case 2: n.Icono = 'icon--bag';
                    break;
                  case 3: n.Icono = 'icon--users';
                    break;
                  case 4: n.Icono = 'icon--warning';
                    break;
                  default: n.Icono = 'icon--exclamation';
                    break;
                }

                n.habilitarUrl = n.CveContribuyente == Contribuyente.CveContribuyente && n.Url;

              });

              $scope.notificaciones = [...$scope.notificaciones, ...nuevasNotificaciones];
              $scope.notificacionesSinLeer = data.Respuesta.NotificacionesSinLeer;
              $scope.hayMasNotificaciones = !data.Respuesta.NoTieneNotificaciones;

            }

          }, angular.noop);
      };

      obtenerNotificaciones();

      $scope.mostrarMasNotificaciones = () => {
        $scope.indiceNotificaciones++;
        obtenerNotificaciones();
      };

      $scope.abrirLiga = notificacion => {

        if (notificacion.FechaLeido) {
          if (notificacion.Url) {
            if (notificacion.CveContribuyente == Contribuyente.CveContribuyente) {
              $window.open(notificacion.Url, '_self');
            }
          }
        } else {
          apiCall.post('DesactivarNotificacion', { cveNotificacion: notificacion.CveNotificacion })
            .finally(() => {

              if (!notificacion.FechaLeido) {
                notificacion.FechaLeido = Date.now();
                $scope.notificacionesSinLeer = $scope.notificacionesSinLeer > 0 ? $scope.notificacionesSinLeer - 1 : 0;
              }

              if (notificacion.Url) {
                if (notificacion.CveContribuyente == Contribuyente.CveContribuyente) {
                  $window.open(notificacion.Url, '_self');
                }
              }
            });
        }
        
      };

    })
  .controller('alertCtrl', ($scope, mostrarNotificacion) => {
    $scope.notificaciones = mostrarNotificacion;
    $scope.closeAlert = () => {
      $scope.notificaciones.clear();
    };
    })
    .controller('EditarNombreContraseniaUsuarioCtrl', ($scope, $uibModalInstance, callToWebService, datos) => {
        if (datos) {
            $scope.nombreCliente = datos.UsuarioPersonaNombre;
            $scope.apPaterno = datos.UsuarioApaterno;
            $scope.apMaterno = datos.UsuarioAmaterno;
            $scope.email = datos.UsuarioCorreo;
        }
        $scope.password = '';
        $scope.$watch('password', function () {
            var inputPwd = $('#newPwdInput');
            var inputPwdConf = $('#confPwdInput');
            if ($scope.password.length > 0) {
                inputPwd.attr("disabled", false);
                inputPwdConf.attr("disabled", false);
            }
            else {
                inputPwd.attr("disabled", true);
                inputPwdConf.attr("disabled", true);
                $scope.newPassword = '';
                $scope.confirmPassword = '';
            }
        }, true);

        $scope.$watch('newPassword', function () {
            $scope.pwdSecurityBar = 0;
            var viewValue = $scope.newPassword;

            var pwdValidLength = (viewValue && viewValue.length >= 8 ? 'valid' : undefined);
            var pwdHasLetter = (viewValue && /[A-z]/.test(viewValue)) ? 'valid' : undefined;
            var pwdHasNumber = (viewValue && /\d/.test(viewValue)) ? 'valid' : undefined;

            if (pwdValidLength)
                $scope.pwdSecurityBar += 33.33;
            if (pwdHasLetter)
                $scope.pwdSecurityBar += 33.33;
            if (pwdHasNumber)
                $scope.pwdSecurityBar += 33.33;

            var pwd = $scope.pwdSecurityBar;

            if (pwd >= 0 && pwd <= 33) {
                $scope.pwdSecurityClass = 'progress-low';
                $scope.segurityLevel = "Baja"
            }
            else if (pwd >= 34 && pwd <= 67) {
                $scope.pwdSecurityClass = 'progress-medium';
                $scope.segurityLevel = "Regular"
            }
            else if (pwd > 67) {
                $scope.pwdSecurityClass = 'progress-high';
                $scope.segurityLevel = "Alta"
            }

            $scope.pwdSecurityBar = Math.round($scope.pwdSecurityBar);

        }, true);

        $scope.closeModal = function (Respuesta) {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.closeModalAlert = function (i) {
            $scope.alert.splice(i, 1);
        };


        $scope.showHidePwd = 'Mostrar';
        $scope.showPwd = false;
        $scope.showPassword = function () {
            var inputPwd = $('#newPwdInput');
            var inputPwdConf = $('#confPwdInput');

            if (!$scope.showPwd) {
                inputPwd.attr("type", "text");
                inputPwdConf.attr("type", "text");
                $scope.showHidePwd = 'Ocultar';
                $scope.showPwd = true;
            }
            else {
                inputPwd.attr("type", "password");
                inputPwdConf.attr("type", "password");
                $scope.showHidePwd = 'Mostrar';
                $scope.showPwd = false;
            }
        };


        $scope.saveChanges = function (form) {
            var gotoService = true;
            if (form.$valid) {
                if (form.password.$viewValue) {
                    if (form.newPassword.$viewValue && form.confirmPassword.$viewValue) {
                        if (form.newPassword.$viewValue == form.confirmPassword.$viewValue) {
                        }
                        else {
                            gotoService = false;
                            $scope.alert = [];
                            $scope.alert.push({ type: 'error', msg: "Las contrase\u00F1as no coinciden" });
                        }
                    }
                    else {
                        gotoService = false;
                        $scope.alert = [];
                        $scope.alert.push({ type: 'error', msg: "Escribe y confirma la nueva contrase\u00F1a" });
                    }

                }
                else {
                    gotoService = true;
                }
            }
            else {
                gotoService = false;
            }

            if (gotoService) {
                var dataInfo = {
                    datosUsuario: {
                        Password: form.newPassword.$viewValue,
                        //Correo: form.email.$viewValue,
                        Nombre: form.nombre.$viewValue,
                        ApellidoPaterno: form.paterno.$viewValue,
                        ApellidoMaterno: form.materno.$viewValue,
                        AntiguoPassword: form.password.$viewValue,
                        ConfirmacionPassword: form.confirmPassword.$viewValue
                    }
                };
                //llamado editar usuario
                callToWebService.postCall('EditarUsuario', dataInfo,
                    function success(data) {
                        if (data.Respuesta && !data.EsError) {
                            $uibModalInstance.close(data);
                        }
                        else {
                            $scope.alert = [];
                            $scope.alert.push({ type: 'error', msg: data.Mensaje });
                        }
                    },
                    function error(data) {

                    });

            }
        };
    })
  .service('mostrarNotificacion', Notification => {
    const serv = {};

    serv.error = msg => Notification.error({message: msg, title: 'Error'});
      
    serv.info = msg => Notification(msg);

    return serv;
  })
  .service('callToWebService', [
    '$http', '$state',
    function ($http, $state) {
      this.postCall = function (endpoint, postData, succesCB, errorCB) {
        $http({
          method: 'POST',
          url: '../../../servicios/PortalServicio.svc/' + endpoint,
          data: JSON.stringify(postData),
          headers: { "Content-Type": "application/json; charset=utf-8" }
        })
          .then(function ({ data }) {
            if (data && data.Respuesta && data.Respuesta.CodigoRespuesta == 401) {
              $state.transitionTo('inicio.mejoras_precios');
            }
            succesCB(data);
          },
          function ({ data, responseCode }) {
            if (responseCode == 401) {
              window.location = '/Login.aspx';
            }
            else if (responseCode == 403) {
              $state.transitionTo('inicio.mejoras_precios');
            }
            else {
              errorCB(data);
            }
          });
      };

    }])
  .service('dateTools', [
    function () {
      var defaultFormat = "DD/MM/YY";
      this.getTimeForWCF = function (dateString, dateFormat) {
        var format = (dateFormat) ? dateFormat : defaultFormat;
        var dateObj = moment(dateString, format);
        dateObj = dateObj._d;
        var dateUTC = new Date(Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), dateObj.getHours(), dateObj.getMinutes(), dateObj.getSeconds(), dateObj.getMilliseconds()));
        return "/Date(" + dateUTC.getTime() + ")/";
      };
      this.isValidDate = function (dateString, dateFormat) {
        var format = (dateFormat) ? dateFormat : defaultFormat;
        return moment(dateString, format, true).isValid();
      };
      this.getDateFromWCF = function (wcfDateString) {
        if (!wcfDateString) return wcfDateString;
        var utcDate = new Date(parseInt(/\/Date\((.+)\)\//.exec(wcfDateString)[1]));
        var dateObj = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000); // compensate timezone offset from minutes to milliseconds
        return dateObj;
      };
      this.getDateStringFromWCF = function (wcfDateString, dateFormat) {
        if (!wcfDateString) return wcfDateString;
        var format = (dateFormat) ? dateFormat : defaultFormat;
        return moment(this.getDateFromWCF(wcfDateString)).format(format);
      };
    }
  ])
  .service('groupBy', () => {
    return function (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };
  })
    .constant('Contribuyente', {
        CveContribuyente: 0
    })
    .run(
    ($rootScope, $state, $window, $location, $sce, $transitions, $cookies, localStorageService, Contribuyente, authorization) => {
    $rootScope.$state = $state;

    Contribuyente.CveContribuyente = $cookies.get('contribuyente') || 0;

    $rootScope.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src);
    };

    if (angular.isFunction($window.ga)) {
      $window.ga('create', 'UA-43438823-2', 'auto', { 'siteSpeedSampleRate': 10 });
    }

    if ($window.moment && angular.isFunction($window.moment.locale)) {
      $window.moment.locale('es');
    }

    $transitions.onStart({}, ({ _targetState: { _definition: toState } }) => {
        $rootScope.toState = toState;
        //$rootScope.toStateParams = toStateParams;          
        return authorization.authorize();
    });

    // track pageview on state change
    $transitions.onSuccess({}, () => {
        let path = $location.path().split('/');
        let newPath = path.reduce((a, v) => {
            let number = parseInt(v);
            return a += !isNaN(number) && angular.isNumber(number) ? "" : "/" + v;
        });

        if (angular.isFunction($window.ga)) {
            $window.ga('set', 'page', newPath);
            $window.ga('send', 'pageview', newPath);
        }
    });

  });

export default m;
